import {
  createMigrate,
  PersistConfig,
  persistReducer,
  persistStore,
} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { rootReducer, RootState } from './rootReducer'
import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import { api } from '../api/BaseApi'
import { rtkQueryErrorLogger } from './middleware/rtkQueryErrorLogger'
import { versionsApi } from '../api/VersionsApi'
import { microserviceApi } from '../api/microservice/MicroserviceBaseApi'

const migrations = {
  0: (state: any) => {
    return {
      ...state,
    }
  },
  1: (state: any) => {
    return {
      ...state,
      foodBoxAuth: {
        ...state.foodBoxAuth,
        FOTOBOX: {
          credentials: {
            token: null,
          },
        },
      },
    }
  },
  2: (state: any) => {
    return {
      ...state,
      foodBoxAuth: {
        ...state.foodBoxAuth,
        COOK: {
          credentials: {
            token: null,
          },
        },
      },
    }
  },
  3: (state: any) => {
    return {
      ...state,
      foodBoxAuth: {
        ...state.foodBoxAuth,
        WAITER_WEB: {
          credentials: {
            token: null,
          },
        },
      },
    }
  },
}

const persistConfig: PersistConfig<RootState> = {
  key: 'foodBoxAuth',
  storage,
  version: 3,
  whitelist: ['foodBoxAuth', 'buffet', 'cook', 'fcmToken', 'options'],
  migrate: createMigrate(migrations, { debug: false }),
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat([
      api.middleware,
      versionsApi.middleware,
      microserviceApi.middleware,
      rtkQueryErrorLogger,
    ]),
  devTools: process.env.NODE_ENV !== 'production',
})

export const persistor = persistStore(store)

export type AppDispatch = typeof store.dispatch
export type AppThunk = ThunkAction<void, RootState, unknown, Action<string>>
export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
